export const APP_TITLE = "Catsoup Radio";
export const APP_SUBTITLE = "A little home‑made radio, just for you.";